import React from 'react';
import { Checkbox } from '@material-ui/core';
import { withStyles } from '@material-ui/core/styles';
import CheckCircleIcon from '@material-ui/icons/CheckCircle';
import RadioButtonUncheckedIcon from '@material-ui/icons/RadioButtonUnchecked';

type RoundedCheckboxType = {
  onChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
  checked?: boolean;
};

const RoundedCheckbox = withStyles({
  root: {
    color: '#CCC',
    padding: 0,
    '&$checked': {
      color: '#F36969',
    },
  },
  checked: {},
})(({ onChange, checked, ...rest }: RoundedCheckboxType) => (
  <Checkbox
    color="default"
    icon={<RadioButtonUncheckedIcon />}
    checkedIcon={<CheckCircleIcon />}
    onChange={onChange}
    checked={checked}
    {...rest}
  />
));

export default RoundedCheckbox;
